import * as React from "react";
import { RttForm } from "./components/RttForm";
import "./css/globalfont.css";
import "./css/tooltip.module.css";
import { datadogRum } from "@datadog/browser-rum";
import { getInitialValues } from "./support/InitialValues";

let isRumInitialized = false;

const App = () => {
  React.useEffect(() => {
    if (typeof window === "undefined" || isRumInitialized) return;

    const version = process.env.REACT_APP_VERSION || "0.0.0";
    const traceId = document
      .querySelector('meta[name="dd-trace-id"]')
      ?.getAttribute("content");
    const spanId = document
      .querySelector('meta[name="dd-span-id"]')
      ?.getAttribute("content");

    datadogRum.init({
      applicationId: "8d380e9e-54d7-47cb-a0bf-b965a0c3d928",
      clientToken: "pub80c80b1bf93562cf2bc487b8e73e62a6",
      site: "datadoghq.com",
      service: "rtt-ui",
      env: process.env.REACT_APP_DD_ENV || "localhost",
      version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
      beforeSend: (event: any) => {
        if (traceId && spanId) {
          event.dd = { trace_id: traceId, span_id: spanId };
        }
        return true;
      }
    });

    isRumInitialized = true;
    datadogRum.startSessionReplayRecording();
  }, []);

  React.useEffect(() => {
    const agreementId = getInitialValues().agreementId;
    if (isRumInitialized && agreementId) {
      try {
        datadogRum.setUser({ id: agreementId });
      } catch (error) {
        console.warn("Failed to set RUM user context:", error);
      }
    }
  }, []);

  return <RttForm />;
};

export default App;
